module.exports = __webpack_public_path__ + "img/brick-horizontal.9b356b80.svg";